

































import Vue from 'vue';
import CardBrand from '@/components/CardBrand.vue';
import ProductList from '@/components/ProductList.vue';
import * as api from '@/api';
import CardContainer from '@/components/CardContainer.vue';

export default Vue.extend({
    name: 'SearchResults',
    components: {
        CardBrand,
        CardContainer,
        ProductList,
    },
    data() {
        return {
            dataLoading: true,
            activeName: 'product',
            brandCount: 0 as number,
            productCount: 0 as number,
            brandCards: [] as api.BrandCard[],
        };
    },
    computed: {
        keyword(): string {
            return this.$route.query.keyword as string || '';
        },
        type(): number | null {
            if (Array.isArray(this.$route.query.type)) {
                return null;
            }
            if (this.$route.query.type) {
                return parseInt(this.$route.query.type, 10);
            }
            return null;
        },
    },
    watch: {
        keyword() {
            this.fetchData();
            this.fetchProductList();
        },
    },
    async created() {
        this.fetchData();
        this.fetchProductList();
    },
    methods: {
        async fetchData() {
            const res = await api.getBrandList({
                name: this.keyword,
            });
            if (!api.error(res)) {
                this.brandCards = res.data.items;
                this.brandCount = res.data.totalCount;
            }
            this.dataLoading = false;
        },
        async fetchProductList() {
            const res = await api.getProductList({
                keyword: this.keyword,
            });
            if (!api.error(res)) {
                this.productCount = res.data.totalCount;
            }
        },
        async loadMoreBrands() {
            this.dataLoading = true;
            const res = await api.getBrandList({
                name: this.keyword,
                skipCount: this.brandCards.length,
            });
            if (!api.error(res)) {
                this.brandCards = [...this.brandCards, ...res.data.items];
            }
            this.dataLoading = false;
        },
    },
});
